const apps = require('./apps.json')

class Price {
  constructor (main, cents, full) {
    this.main = main
    this.cents = cents
    this.full = full
  }
}

class Data {
  constructor (main, bonus, full, apps) {
    this.main = main
    this.bonus = bonus
    this.full = full
    this.apps = apps
  }
}

class Option {
  constructor (description) {
    this.description = description
  }
}

class App {
  constructor (icon, name, description) {
    this.icon = icon
    this.name = name
    this.description = description
  }
}
class Apps {
  constructor (limited, unlimited) {
    this.limited = limited
    this.unlimited = unlimited
  }
}

class Benefit {
  constructor (includedApps) {
    this.includedApps = createApps(includedApps)
  }
}

export class Offer {
  constructor (id, price, data, shortDescription, longDescription, subDescription, altDescription, hiddenHome, options, apps, benefit, showInHeader) {
    this.id = id
    this.price = {
      adesao: new Price(price.adesao.main, price.adesao.cents, price.adesao.full),
      recorrencia: new Price(price.recorrencia.main, price.recorrencia.cents, price.recorrencia.full)
    }
    this.data = new Data(data.main, data.bonus, data.full, data.apps)
    this.shortDescription = shortDescription
    this.longDescription = longDescription
    this.subDescription = subDescription
    this.altDescription = altDescription
    this.hiddenHome = hiddenHome
    this.options = options?.map(option => new Option(option))
    this.apps = new Apps(createApps(apps.limitados), createApps(apps.ilimitados))
    this.benefit = new Benefit(benefit.includedApps)
    this.showInHeader = showInHeader
  }
}

function createApps (arr) {
  if (!arr) return []
  return arr.map(app => {
    if (apps[app]) {
      const { icon, name, description } = apps[app]
      return new App(icon, name, description)
    }
  }).filter(v => v)
}
